import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:/openy-admin-all/openy-wxms-web2026-09-01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadH5Info, getApplyList, getAppletCode } from "@/api/mini";
import { appletCode } from "@/views/contentManagement/micro/index";
import QRCode from 'qrcodejs2';
export default {
  data: function data() {
    return {
      show: false,
      title: '**分享',
      path: '',
      type: '',
      isNoBtn: false,
      weappStatus: "",
      isShowApple: false,
      appletCode: "",
      dts: "",
      copy_url: "",
      copy_applet_url: "",
      id: ''
    };
  },
  mounted: function mounted() {},
  methods: {
    open: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, type, text, path, isNoBtn) {
        var _this = this;

        var loading, res, result, t;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                if (text) this.title = text;
                if (path) this.path = path;
                if (type) this.type = type;
                if (id) this.id = id;
                if (isNoBtn) this.isNoBtn = isNoBtn;

                if (!(type != 140 && type != 220)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 9;
                return getApplyList(sessionStorage.getItem("webId"));

              case 9:
                res = _context.sent;

                if (!(res.code !== "000000")) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return");

              case 12:
                this.weappStatus = res.datas.weappStatus;

                if (!(res.datas.weappStatus == 2)) {
                  _context.next = 33;
                  break;
                }

                _context.prev = 14;

                if (!(type == 120)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return appletCode(this.id);

              case 18:
                _context.t0 = _context.sent;
                _context.next = 24;
                break;

              case 21:
                _context.next = 23;
                return getAppletCode(this.id, type);

              case 23:
                _context.t0 = _context.sent;

              case 24:
                result = _context.t0;
                this.appletCode = type == 120 ? result.datas.wxaCode : result.datas.playBillUrl ? result.datas.playBillUrl : '';
                this.copy_applet_url = result.datas.miniPath;
                this.isShowApple = true;
                _context.next = 33;
                break;

              case 30:
                _context.prev = 30;
                _context.t1 = _context["catch"](14);
                this.isShowApple = false;

              case 33:
                if (!(type == 140)) {
                  _context.next = 37;
                  break;
                }

                this.dts = path;
                _context.next = 41;
                break;

              case 37:
                _context.next = 39;
                return loadH5Info(sessionStorage.getItem("webId"));

              case 39:
                t = _context.sent;

                if (t.datas.domain) {
                  this.dts = t.datas.domain + path;
                } else {
                  this.dts = process.env.VUE_APP_BASE_API3 + path + '&appId=' + sessionStorage.getItem("webId");
                }

              case 41:
                setTimeout(function () {
                  _this.$refs.exCodeRef.innerHTML = "";
                  new QRCode(_this.$refs.exCodeRef, {
                    width: 150,
                    // 设置宽度，单位像素
                    height: 150,
                    // 设置高度，单位像素
                    text: _this.dts // 设置二维码内容或跳转地址

                  });
                  _this.copy_url = _this.dts;
                }, 300);
                this.show = true;
                loading.close();

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[14, 30]]);
      }));

      function open(_x, _x2, _x3, _x4, _x5) {
        return _open.apply(this, arguments);
      }

      return open;
    }(),
    onCancel: function onCancel() {
      this.show = false;
    },
    onConfirma: function onConfirma() {
      var data = {
        id: '12312312',
        name: "132123132"
      };
      this.onConfirm(data);
    },

    /**
     * 下载小程序码
     */
    downloadAppleImg: function downloadAppleImg() {
      var img = document.getElementById('apple-qrcode').getElementsByTagName('img')[0];
      var url = img.src;
      var a = document.createElement('a');
      var event = new MouseEvent('click');
      a.download = "".concat(this.title, "\u5C0F\u7A0B\u5E8F\u7801.jpg");
      a.href = url;
      a.dispatchEvent(event);
    },

    /**
     * 下载二维码
     */
    downloadImg: function downloadImg() {
      var img = this.$refs['exCodeRef'].getElementsByTagName('img')[0]; // 构建画布

      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0); // 构造url

      var url = canvas.toDataURL('image/png');
      document.getElementById('downloadImg').setAttribute('href', url);
      document.getElementById('downloadImg').setAttribute('download', "".concat(this.title, "\u4E8C\u7EF4\u7801.jpg"));
      document.getElementById('downloadImg').click();
    },

    /**
     * 复制链接
     */
    copyPerviewLink: function copyPerviewLink() {
      var Url2 = document.querySelector("#copy");
      Url2.value = this.dts;
      Url2.select(); // 选择对象

      document.execCommand("copy"); // 执行浏览器复制命令

      this.$message({
        message: "复制成功",
        type: 'success'
      });
    },
    copyPerviewAppletLink: function copyPerviewAppletLink() {
      var Url2 = document.getElementById("copy_applet");
      Url2.value = this.copy_applet_url;
      Url2.select(); // 选择对象

      document.execCommand("copy"); // 执行浏览器复制命令

      this.$message({
        message: "复制成功",
        type: 'success'
      });
    }
  }
};